import { ENDPOINTS } from "config/endpoints";
import client from "utils/client";
import { useQuery } from "react-query";
import { Request } from "types/request";
import { PaginatedResponse } from "types/response";
import { Block } from "types/block";
import Error from "types/error";

export default function useSharedBlocks(
  page?: number,
  size?: number,
  search?: Record<string, string>
) {
  const request: Request = {
    url: ENDPOINTS.shares.sharedBlocks,
    config: {
      method: "GET",
      params: { page, size, ...search },
    },
  };

  const requestConfig = {
    queryKey: [
      ENDPOINTS.shares.sharedBlocks,
      page,
      size,
      search && JSON.stringify(search),
    ],
    queryFn: () => client(request).then((res) => res.data),
  };

  const { data, ...rest } = useQuery<PaginatedResponse<Block[]>, Error>(
    requestConfig
  );

  return { data, ...rest };
}
